import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSlackInfoCreator } from 'creators/slack';

import MentionsDropDown from 'components/mentions-drop-down';

const Mentions = class extends Component {
  render() {
    const { listeneeClass, slack, onMentionClick } = this.props;
    const { team_info: teamInfo } = slack;

    if (!teamInfo) {
      return null;
    }

    return (
      <div>
        <MentionsDropDown
          title="People"
          editorClass={$(listeneeClass)}
          trigger="@"
          handleSelection={onMentionClick}
          selfPositioning={true}
          suggestions={teamInfo.people.map(row => {
            return {
              username: row.name,
              name: row.profile.real_name || row.name,
              avatar: row.profile.image_72,
              id: row.id,
            };
          })}
        />
        <MentionsDropDown
          title="Channel"
          editorClass={$(listeneeClass)}
          trigger="#"
          showTrigger={true}
          handleSelection={onMentionClick}
          selfPositioning={true}
          suggestions={teamInfo.channels.map(row => {
            return { name: row.name, id: row.id };
          })}
        />
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    const { slack } = this.props;

    if (!slack.team_info && !slack.fetching) {
      this.props.getSlackInfoCreator();
    }
  }

  componentDidMount() {
    const $listenee = $(this.props.listeneeClass);

    if ($listenee[0]) {
      $listenee[0].addEventListener('keydown', () => {
        // we force update here because the MentionsDropDown does not know tha
        this.forceUpdate();
      });
    }
  }
};

const mapStateToProps = state => {
  const { slack } = state;

  return { slack };
};

const mapDispatchToProps = dispatch => {
  return {
    getSlackInfoCreator: () => dispatch(getSlackInfoCreator()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Mentions);
